// extracted by mini-css-extract-plugin
export var boxItems = "_9b-1";
export var boxItemsLg = "_9b-2";
export var button = "_9b-7";
export var buttonHoverless = "_9b-9";
export var buttonLg = "_9b-8";
export var filterGroupBox = "_9b-0";
export var icon = "_9b-3";
export var iconSecondary = "_9b-6";
export var iconWrapper = "_9b-4";
export var iconWrapperLg = "_9b-5";
export var truncatedLabel = "_9b-a";